module.exports = __webpack_public_path__ + "static/media/examplePhoto1.ed25ef37.png";